<template>
  <div class="scenetable">
    <el-table
      :data=scenes
      empty-text="No Scenes Found"
      style="width: 100%">

      <el-table-column
        label="Name"
        prop="name"
        header-align="center">
      </el-table-column>

      <el-table-column
        label="Light Percentage"
        prop="percentage"
        header-align="center">
      </el-table-column>

      <el-table-column
        label="Power Consumption"
        prop="consumption"
        header-align="center">
      </el-table-column>
      
      <el-table-column
        label="Type"
        prop="scene_type"
        header-align="center">
      </el-table-column>
      
      <el-table-column
        v-if="userIsSuperAdmin"
        label="Operations"
        align="center">
          <template slot-scope="props">
            <operations 
              :id="props.row.scene_id" 
              :disableMore="true"
              @edit="editScene(props.row)" 
              @delete="deleteScene">
            </operations>
        </template>
      </el-table-column>
      
    </el-table>
  </div>
</template>

<script>
  import auth from '../../../auth'
  import requests from '../../../requests';

  import operations from '../OpButtons.vue';

  export default {
    name: 'scenetable',
    props: ['id'],
    data () {
      return {
        scenes:[],
        userIsSuperAdmin: false,
      }
    },
    beforeMount(){
      var profile = JSON.parse(auth.getProfile());
      this.userIsSuperAdmin = (profile.role === 3);
      // this.userIsSuperAdmin = true;

      this.getScenes();
    },
    methods: {
      getScenes(){
        this.scenes = [];
        var context = this;

        requests.getScenes(this, context.id, function(result) {
          if(result.action === 'success') {
            var scenes = result.data;
            for(var i = 0; i < scenes.length; i++) {
              context.scenes.push(scenes[i]);
              context.fieldName = scenes[i].field_name;
            }
            console.log(context.scenes);
          } else {
            if(result.msg.message && result.msg.message !== "scenes is null") {
              context.$message({
                type: 'error',
                message: 'Failed to recieve scenes: ' + result.msg,
              });
            }
          }
        });
      },
      editScene(sceneData) {
        this.$emit('editScene', sceneData);
      },
      deleteScene(id) {
        this.$emit('deleteScene', id);
      },
    },
    components: {
      'operations': operations
    }
  }
  

</script>

<style>
  .el-table .cell {
    word-break: normal !important;
  }

</style>




// WEBPACK FOOTER //
// SceneTable.vue?feae985e